export default "__VITE_ASSET__CGR7eYrF__"